import {
    requestPublic,
    request
} from './request.js'

// 学员修改手机号
export function updateTelPhone(tel, code) {
    return request({
        url: '/api2/StudentAccommodationApi/StudentManage/UpdateTelPhone',
        method: 'post',
        params: {
            newTelPhone: tel,
            code: code
        }
    })
}
// 学员资料完善
export function updateStudentInfo(name, idCard) {
    return request({
        url: '/api2/StudentAccommodationApi/StudentManage/UpdateStudentInfo',
        method: 'post',
        data: {
            name: name,
            idCard: idCard
        }
    })
}